import React from 'react';

export const MONSTER_ME_LANDING_HERO = 'monsterMeLandingHero';
export const MONSTER_ME_SERIES_HERO = 'monsterMeBookHero';
export const MONSTER_ME_MEDIA_TYPE = 'monsterMeLanding';

export const PARTNERSHIPS_AND_RESOURCES = [
  {
    description: (
      <div>
        <p style={{ marginBottom: '1em' }}>
          <a href="https://ipopstories.com/monster-me-contest/" target="blank">
            Calling All Monster Makers!
          </a>{' '}
        </p>
        <p style={{ marginBottom: '1em' }}>
          Hey kids ages K-12! Enter your Monster drawing for a chance to be one
          of 10 lucky winners.
        </p>
        <p style={{ marginBottom: '1em' }}>
          Winners will receive awesome prizes from games and gift cards to
          professional art software – and everyone gets a FREE digital comic!
        </p>
        <p style={{ marginBottom: '1em' }}>
          For every entry, we will also donate Monster Me books to amazing
          children’s causes! Contest begins June 9 through September 12, 2021
        </p>
        <a href="https://ipopstories.com/monster-me-contest/" target="blank">
          Enter to win!
        </a>
      </div>
    ),
    imageUrl:
      'https://www.funbrain.com/assets/img/monster-me/monster-me-contest.png',
  },
];
